import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

/**
 * Checks if a user is not authenticated (anonymous) and redirects authenticated users to the home page.
 */
@Injectable()
export class AnonymousGuard {
  constructor(
    private router: Router,
    private cookieService: CookieService,
  ) {}

  public canActivate(): boolean {
    if (!this.cookieService.check('token')) {
      return true;
    }

    return false;
  }
}
